import { lt } from '@mews/framework';
import { TextKey } from '@mews-commander/enums';
import { RoutingRuleBillAggregationType } from '@mews-commander/data-access';
import { TargetBillFormFields } from '../../../../schemas';

export const aggregationTypeOptions = [
    {
        label: lt(TextKey.RoutingRulesFormCompanyBillLabelAggregateAll),
        value: RoutingRuleBillAggregationType.AggregateAll,
        name: RoutingRuleBillAggregationType.AggregateAll,
    },
    {
        label: lt(TextKey.RoutingRulesFormCompanyBillLabelAggregatePerReservationGroup),
        value: RoutingRuleBillAggregationType.AggregatePerReservationGroup,
        name: RoutingRuleBillAggregationType.AggregatePerReservationGroup,
    },
    {
        label: lt(TextKey.RoutingRulesFormCompanyBillLabelOnePerReservation),
        value: RoutingRuleBillAggregationType.OnePerReservation,
        name: RoutingRuleBillAggregationType.OnePerReservation,
    },
    {
        label: lt(TextKey.RoutingRulesFormCompanyBillLabelAggregateByCustomer),
        value: RoutingRuleBillAggregationType.AggregateByCustomer,
        name: RoutingRuleBillAggregationType.AggregateByCustomer,
    },
];

export const includeCompanyDetailsOption = [
    {
        label: lt(TextKey.RoutingRulesFormGuestBillDescriptionIncludeCompanyDetails),
        value: TargetBillFormFields.IncludeCompanyDetails,
        name: TargetBillFormFields.IncludeCompanyDetails,
        description: lt(TextKey.RoutingRulesFormGuestBillLabelIncludeCompanyDetails),
    },
];
